import { render, staticRenderFns } from "./registeredSubAccount.vue?vue&type=template&id=faa8d9d4&scoped=true&"
import script from "./registeredSubAccount.vue?vue&type=script&lang=js&"
export * from "./registeredSubAccount.vue?vue&type=script&lang=js&"
import style0 from "./registeredSubAccount.vue?vue&type=style&index=0&id=faa8d9d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa8d9d4",
  null
  
)

component.options.__file = "registeredSubAccount.vue"
export default component.exports